import { makeStyles } from "@material-ui/core";

export const css = makeStyles(() => ({
    modal: {
        textAlign: "center",
    },
    container: {
        display: "flex",
        flexDirection: "column",
        padding: "0 30px",
    },
    header: {
        display: "flex",
        alignItems: "center",
        margin: "0 auto",
    },
    title: {
        fontSize: "18px",
        fontWeight: "bold",
        margin: "20px auto",
    },
    closeButton: {
        zIndex: 1,
        position: "absolute",
        marginLeft: "68.5%",
        cursor: "pointer",
    },
    text: {
        fontSize: "16px",
        fontWeight: "500",
        marginBottom: "30px",
    },
    produtos: {
        margin: "0 0 30px 15px",
        display: "flex",
        flexDirection: "column",
    },
}));
